import { render, staticRenderFns } from "./ComplexTaskFlowModal.vue?vue&type=template&id=496ae325"
import script from "./ComplexTaskFlowModal.vue?vue&type=script&lang=js"
export * from "./ComplexTaskFlowModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports